import * as classes from "./button.module.scss";
import classNames from "classnames";
import { FC, ReactElement } from "react";

interface CommonProps {
  className?: string;
  type: "link" | "button" | "dumb";
  size?: "large" | "small";
  style?: "outline" | "filled";
  label: string;
  icon?: ReactElement;
  iconOnly?: boolean;
  onClick?(): void;
  href?: string;
  styleProps?: any;
  disabled?: boolean;
}

interface DumbProps extends CommonProps {
  type: "dumb";
  href?: never;
  onClick?(): never;
}

interface LinkProps extends CommonProps {
  type: "link";
  href: string;
  onClick?(): never;
}

interface ButtonProps extends CommonProps {
  type: "button";
  onClick(): void;
  href?: never;
}

const Button: FC<DumbProps | LinkProps | ButtonProps> = ({
  className: classNameProp,
  disabled,
  type,
  style = "filled",
  size = "small",
  label,
  icon,
  iconOnly = false,
  href,
  onClick,
  styleProps,
}) => {
  const className = classNames(
    classNameProp,
    classes.root,
    classes[`root--${style}`],
    classes[`root--${size}`],
    {
      [classes["root--icon-only"]]: !!icon && iconOnly,
      [classes["root--text-only"]]: !icon,
      [classes["root--has-icon"]]: !!icon,
      [classes["root--disabled"]]: disabled,
    }
  );

  const inner = (
    <>
      {icon ? icon : null}
      {!iconOnly ? label : null}
    </>
  );

  if (type === "button") {
    return (
      <button
        style={styleProps}
        className={className}
        aria-label={label}
        onClick={onClick}
        disabled={disabled}
      >
        {inner}
      </button>
    );
  }

  if (type === "link") {
    return (
      <a
        style={styleProps}
        className={className}
        href={href}
        aria-label={label}
        rel="noopener noreferrer"
        target="_blank"
      >
        {inner}
      </a>
    );
  }

  return (
    <div style={styleProps} className={className}>
      {inner}
    </div>
  );
};

export default Button;
